import type {
	Monitor as MonitorState,
	ScreenerState,
} from "epsm-api-types/models";
import type { MonitorStateService } from "@/components/widgets/Monitor/lib/services/MonitorStateService";
import type { ScreenerStateService } from "@/components/widgets/Screener/services/ScreenerStateService";

export const getDefaultName = async (
	widgetName: string,
	userId: string,
	setName: React.Dispatch<string> | undefined,
	service: MonitorStateService | ScreenerStateService,
): Promise<string> => {
	const response = await service.getStates(userId);
	const states: ScreenerState[] | MonitorState[] = response?.data ?? [];

	const newName = getNextDefaultName(
		widgetName,
		states.map((state) => state.itemName),
	);
	if (setName) setName(newName);
	return newName;
};

export const getNextDefaultName = (
	prefixName: string,
	existingNames: string[],
): string => {
	const lastDefaultNumber = existingNames
		.map((name) => {
			const match = name.match(new RegExp(`^${prefixName}(\\d*)$`, "i"));
			return match && match[1] !== "" ? Number(match[1]) : Number.NaN;
		})
		.filter((num) => !Number.isNaN(num))
		.reduce((max, num) => Math.max(max, num), 0);

	const newName = `${prefixName}${lastDefaultNumber + 1}`;
	return newName;
};
